import { TranslateService } from '@ngx-translate/core';
import { sumBy } from 'lodash';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var LineMapperService = /** @class */ (function () {
    function LineMapperService(translate) {
        this.translate = translate;
        this.timelineOptions = {
            lastSevenDays: moment().subtract(6, 'days').startOf('day').utc().toISOString(),
            lastThirtyDays: moment().subtract(29, 'days').startOf('day').utc().toISOString(),
            lastNinetyDays: moment().subtract(89, 'days').startOf('day').utc().toISOString(),
            lastSixMonths: moment().subtract(5, 'months').startOf('day').utc().toISOString(),
            lastTwelveMonths: moment().subtract(11, 'months').startOf('day').utc().toISOString(),
        };
        this.columnsByTimelineOption = {
            lastSevenDays: 7,
            lastThirtyDays: 10,
            lastNinetyDays: 9,
            lastSixMonths: 6,
            lastTwelveMonths: 12,
        };
    }
    LineMapperService.prototype.toLineChartFormat = function (accountRatingsAverageByTimeline, timelineOption) {
        if (timelineOption === 'lastSevenDays') {
            return this.toTimelineLastSevenDays(accountRatingsAverageByTimeline, timelineOption);
        }
        if (timelineOption === 'lastThirtyDays' || timelineOption === 'lastNinetyDays') {
            var range = timelineOption === 'lastThirtyDays' ? 3 : 10;
            return this.toTimelineLastWithRangedDays(accountRatingsAverageByTimeline, range, timelineOption);
        }
        return this.toTimelineLastMonths(accountRatingsAverageByTimeline, timelineOption);
    };
    LineMapperService.prototype.toTimelineLastSevenDays = function (data, timelineOption) {
        var timeline = [];
        for (var i = 0; i < this.columnsByTimelineOption[timelineOption]; i++) {
            var date = moment().subtract(i, 'days');
            var formattedDay = moment(date).format('dddd').charAt(0).toUpperCase() + moment(date).format('dddd').slice(1);
            var hasAverageProperty = data[i].hasOwnProperty('average');
            if (hasAverageProperty) {
                timeline.push({
                    name: date.format('ddd DD/MM'),
                    formattedName: formattedDay,
                    initialDate: moment(date).format(),
                    value: data[i].average,
                    totalCount: data[i].totalCount
                });
            }
            else {
                timeline.push({
                    name: date.format('ddd DD/MM'),
                    formattedName: formattedDay,
                    initialDate: moment(date).format(),
                    value: data[i].totalCount
                });
            }
        }
        return [{
                name: this.translate.instant('RATINGS.CARDS.GRAPHIC.AVERAGE.LABEL'),
                series: timeline.reverse()
            }];
    };
    LineMapperService.prototype.toTimelineLastWithRangedDays = function (data, range, timelineOption) {
        var timeline = [];
        var firstDayOfSheet = this.timelineOptions[timelineOption];
        var _loop_1 = function (i) {
            var firstDay = moment(firstDayOfSheet).add(i * range, 'days').format('YYYY-MM-DD');
            var lastDay = moment(firstDay).add(range - 1, 'days').format('YYYY-MM-DD');
            var hasAverageProperty = data[i].hasOwnProperty('average');
            var items = data.filter(function (_a) {
                var completedAt = _a.completedAt;
                return moment(completedAt).isSameOrAfter(firstDay) && moment(completedAt).isSameOrBefore(lastDay);
            });
            var totalCount = items.reduce(function (accumulator, item) {
                return accumulator + item.totalCount;
            }, 0);
            if (hasAverageProperty) {
                var averageValue = this_1.calcAverageOfItems(items);
                timeline.push({
                    name: moment(firstDay).format('DD/MM') + " - " + moment(lastDay).format('DD/MM'),
                    formattedName: moment(firstDay).format('DD/MM') + " - " + moment(lastDay).format('DD/MM'),
                    initialDate: moment(firstDay).format(),
                    finalDate: moment(lastDay).format(),
                    totalCount: totalCount,
                    value: averageValue,
                });
            }
            else {
                timeline.push({
                    name: moment(firstDay).format('DD/MM') + " - " + moment(lastDay).format('DD/MM'),
                    formattedName: moment(firstDay).format('DD/MM') + " - " + moment(lastDay).format('DD/MM'),
                    initialDate: moment(firstDay).format(),
                    finalDate: moment(lastDay).format(),
                    value: totalCount,
                });
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.columnsByTimelineOption[timelineOption]; i++) {
            _loop_1(i);
        }
        return [{
                name: this.translate.instant('RATINGS.CARDS.GRAPHIC.AVERAGE.LABEL'),
                series: timeline
            }];
    };
    LineMapperService.prototype.toTimelineLastMonths = function (data, timelineOption) {
        var firstDayOfSheet = this.timelineOptions[timelineOption];
        var timeline = [];
        for (var i = 0; i < this.columnsByTimelineOption[timelineOption]; i++) {
            var date = moment(firstDayOfSheet).add(i, 'months').format('YYYY-MM-DD');
            var formattedDate = moment(date).format('MMM').charAt(0).toUpperCase() + moment(date).format('MMM').slice(1);
            var formattedMonth = moment(date).format('MMMM').charAt(0).toUpperCase() + moment(date).format('MMMM').slice(1);
            var hasAverageProperty = data[i].hasOwnProperty('average');
            if (hasAverageProperty) {
                timeline.push({
                    name: formattedDate,
                    formattedName: formattedMonth,
                    initialDate: moment(date).format(),
                    totalCount: data[i].totalCount,
                    value: data[i].average
                });
            }
            else {
                timeline.push({
                    name: formattedDate,
                    formattedName: formattedMonth,
                    initialDate: moment(date).format(),
                    value: data[i].totalCount
                });
            }
        }
        return [{
                name: this.translate.instant('RATINGS.CARDS.GRAPHIC.AVERAGE.LABEL'),
                series: timeline
            }];
    };
    LineMapperService.prototype.calcAverageOfItems = function (items) {
        var sumOfCount = sumBy(items, 'totalCount');
        items.forEach(function (item) {
            item.averageSum = item.totalCount * item.average;
        });
        var sumOfAverageOfAllItems = sumBy(items, 'averageSum');
        if (sumOfAverageOfAllItems !== 0 && sumOfCount !== 0) {
            return sumOfAverageOfAllItems / sumOfCount;
        }
        return 0;
    };
    LineMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LineMapperService_Factory() { return new LineMapperService(i0.ɵɵinject(i1.TranslateService)); }, token: LineMapperService, providedIn: "root" });
    return LineMapperService;
}());
export { LineMapperService };
